export default "__VITE_ASSET__CyMvKrQE__"